@if (showCloseBtn) {
  <button class="close-btn" (click)="handleClose()">
    <icon name="x"></icon>
  </button>
}

@for (section of summary.Sections; track section) {
  <div class="summary-section">
    <table>
      <thead>
        @for (colName of section.ColumnNames; track colName) {
          <th>{{colName}}</th>
        }
      </thead>
      <tbody>
        @for (item of section.Items; track item) {
          <tr>
            <td>
              <h2>{{item.Name}}</h2>
              <h4>{{item.Subcontent}}</h4>
            </td>
            <td>
              <h2>{{item.Value}}</h2>
            </td>
          </tr>
        }
        @if (!section.Items.length) {
          <tr>
            <td>---</td>
            <td>---</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (summary.Action) {
  <button class="hc-btn primary" (click)="summary.Action()">
    @if (summary.HasSelections) {
      <span>View &amp; Change</span>
    }
    @if (!summary.HasSelections) {
      <span>Select {{summary.EntityLabel}}</span>
    }
  </button>
}